import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=dbbda9c2&scoped=true&"
import script from "./consumables.vue?vue&type=script&lang=js&"
export * from "./consumables.vue?vue&type=script&lang=js&"
import style0 from "./consumables.vue?vue&type=style&index=0&id=dbbda9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbda9c2",
  null
  
)

export default component.exports